import React, { FunctionComponent } from 'react';
import { RecordingModel } from 'features/recordings/RecordingModel';
import { PageAnimationFullScreen } from 'components/LayoutAnimations/PageAnimationFullScreen';
import { RecordingWrapper } from 'features/recordings/components/RecordingWrapper';
import { RecordingEmbedHeader } from './RecordingEmbedHeader';
import { RecordingContent } from 'features/recordings/components/RecordingContent';
import { RecordingEmbedFooter } from 'features/recordings/components/RecordingEmbed/RecordingEmbedFooter';

interface RecordingEmbedProps {
  recording: RecordingModel | null;
}

export const RecordingEmbed: FunctionComponent<RecordingEmbedProps> = ({
  recording
}) => {
  return (
    <PageAnimationFullScreen>
      <RecordingWrapper recording={recording}>
        <RecordingEmbedHeader />
        <RecordingContent recording={recording} />
        <RecordingEmbedFooter recording={recording} />
      </RecordingWrapper>
    </PageAnimationFullScreen>
  );
};
